import React from 'react';
import MuiSelect, { SelectProps } from '@material-ui/core/Select';
import { useDisableFocusTrapWithChatProps } from '@components/ChatAwareComponents/utilities/hooks/useDisableFocusTrapWithChatProps/useDisableFocusTrapWithChatProps';

export const ChatAwareSelect: React.FC<SelectProps> = ({ children, ...rest }) => {
	const disableFocusTrapWithChatProps = useDisableFocusTrapWithChatProps();

	const { MenuProps, ...selectProps } = rest;

	return (
		<MuiSelect
			MenuProps={{
				...disableFocusTrapWithChatProps,
				...MenuProps,
			}}
			{...selectProps}
		>
			{children}
		</MuiSelect>
	);
};
